<div class="grid-row-wrap">
<div class="grid-row pointer" (click)="toggleExpand()">
    <div class="list-item chevron-cell" [class.expanded]="isExpanded">
        <img class="chevron-icon" src="/assets/images/expand_more.svg" />
    </div>
    <div class="list-item flex-2 ellipsis ">
        <p class="ellipsis xxx"> {{report?.questionnarieName}}</p>
        <div class="tooltip-abs" *ngIf="report?.questionnarieName">
            <p>{{report?.questionnarieName}}</p>
        </div>
    </div>
    <div class="list-item flex-1">{{ report?.recipientId }}</div>
    <div class="list-item flex-1">{{report?.createDate |queDate }}</div>
    <div class="list-item flex-1_2 sender-name-wrap">
        <div class="circle">
            <p>
                {{
                report?.sender?.firstName
                ? report?.sender?.firstName?.charAt(0)?.toUpperCase()
                : ""
                }}
            </p>
            <p>
                {{
                report?.sender?.lastName
                ? report?.sender?.lastName?.charAt(0)?.toUpperCase()
                : ""
                }}
            </p>
        </div>
        <p class="name">{{ report?.sender?.firstName }} {{ report?.sender?.lastName }}</p>
    </div>
    <div class="list-item flex-1_2 ellipsis">
        <p class="ellipsis xxx approvers-cell">
            <ng-container *ngFor="let approver of report?.approvers; let last = last">
                <span [class.approved]="approver.hasApproved">{{ approver.name }}</span><span
                    *ngIf="!last">, </span>
            </ng-container>
        </p>
        <div class="tooltip-abs" *ngIf="report?.approversDisplay">
            <p>{{ report?.approversDisplay }}</p>
        </div>
    </div>
    <div class="list-item flex-1" [ngSwitch]="report?.formStatus">
        <div *ngSwitchCase="eEnumReplyStatus.Approved" class="status-q approvaled">
            <img src="/assets/images/grid/status/check_circle.svg">
            <p translate>column.reports.formStatusValue.approved</p>
        </div>
        <div *ngSwitchCase="eEnumReplyStatus.PendingApproval" class="status-q pending-approval">
            <img src="/assets/images/grid/status/hourglass.svg">
            <p translate>column.reports.formStatusValue.pending</p>
        </div>
        <div *ngSwitchCase="eEnumReplyStatus.Rejected" class="status-q rejected">
            <img src="/assets/images/grid/status/cancel.svg">
            <p translate>column.reports.formStatusValue.rejected</p>
        </div>
    </div>
    <div class="list-item flex-1">{{ report?.formApprovalDate | queDate }}</div>
   
    <div class="list-item flex-1">{{ report?.mlmLastExportDate | queDate }}</div>
    <div class="list-item flex-0_8">
        <div class="status-q no-icon" [ngClass]="report?.clientCharge ? 'approvaled' : 'pending-approval'">
            <p>{{ (report?.clientCharge ? 'grid.reports.clientChargeYes' : 'grid.reports.clientChargeNo') | translate }}</p>
        </div>
    </div>
    <div class="list-item flex-1_8">
        <que-extra-details [requiredAmount]="report?.requiredAmount" [approvedAmount]="report?.approvedAmount"></que-extra-details>
    </div>
     <div class="list-item flex-1" [ngSwitch]="report?.mlmExportStatus">
        <div *ngSwitchCase="eEnumExportStatus.Exported" class="status-q approvaled">
            <img src="/assets/images/grid/status/check_circle.svg">
            <p translate>column.reports.mlmExportStatusValue.exported</p>
        </div>
        <div *ngSwitchCase="eEnumExportStatus.Failed" class="status-q rejected">
            <img src="/assets/images/grid/status/cancel.svg">
            <p translate>column.reports.mlmExportStatusValue.failed</p>
        </div>
        <div *ngSwitchCase="eEnumExportStatus.NotExported" class="status-q pending-approval">
            <img src="/assets/images/grid/status/hourglass.svg">
            <p translate>column.reports.mlmExportStatusValue.notExported</p>
        </div>
    </div>
    <div class="list-item flex-half last">
        <que-reports-menu-item [report]="report"></que-reports-menu-item>
    </div>
    
</div>
<que-approval-expense-rows
    *ngIf="isExpanded"
    [rows]="expenseRows"
    [loading]="isLoadingExpenseRows"
    [error]="expenseRowsError"
    [approvalId]="report?.id"
    [canEdit]="false"
    (rowClick)="reportClick()">
</que-approval-expense-rows>
</div>
